import * as type from "../mutationTypes";
import api from "../../serve/api";

export const setStones = async ({ commit }) => {
  try {
    commit(type.SET_STONES);
  } catch (error) {
    console.error(error);
  }
};

export const selectStone = ({ commit }, stone) => {
  commit(type.SELECT_STONE, stone);
};



export const resetStones = ({ commit, state}) => {
  try {
    state.stones = []
    commit(type.RESET_STONE_FILTERS, null);
    commit(type.SET_STONES);
  } catch (error) {
    console.error(error);
  }
};



export const setStoneDetail = ({commit}, id) => {
  return new Promise((resolve, reject) => {
    api.get(`stone/${id}`)
      .then(
        res => {
          commit(type.SET_STONE_DETAIL, res.data)
          resolve(res)
        },
        error => {
          console.error(error.response)
          reject(error.response.data.error)
        }
      )
  })
}


export const upLoadFiles3D = async ({ commit }, data) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  const files = new FormData();
  data.files.map((el, i) => {
    return files.append(`files[${i}]`, el, el.name);
  });


  return new Promise((resolve, reject) => {
    api.post(`/3d/${data.stone_id}`, files, config)
      .then(
        (res) => {resolve(res)},
        (error) => {reject(error.response.data.error), console.error(error)}
      );
  });
};


export const deleteFiles3D = async ({action}, stone_id) => {
  return new Promise((resolve, reject) => {
    api.delete(`/3d/${stone_id}`)
      .then(
        (res) => {
          resolve(res)
        },
        (error) => {reject(error.response.data.error), console.error(error)}
      );
  });
}

export const deleteStone = async ({commit}, stone_id) => {
  return new Promise((resolve, reject) => {
    api.delete(`/stone/${stone_id}`)
      .then(
        (res) => {
          commit(type.SET_STONES)
          resolve(res)
        },
        (error) => {reject(error.response.data.error), console.error(error)}
      );
  });
}

export const deleteImg3D = async ({commit}, stone_id) => {
  const data  = {delete_all: false}
  return new Promise((resolve, reject) => {
    api.delete(`/image/${stone_id}`, data )
      .then(
        (res) => {
          commit(type.SET_STONES)
          resolve(res)
        },
        (error) => {reject(error.response.data.error), console.error(error)}
      );
  });
}



export const editeStone = async ({commit}, data) => {
  return new Promise((resolve, reject) => {
    api.put(`/stone/${data.id}`, data)
      .then(
        (res) => {
          commit(type.SET_STONE_DETAIL)
          commit(type.SET_STONES)
          resolve(res)
        },
        (error) => {reject(error), console.error(error)}
      );
  });
}

export const  searchStones =  async ({state, commit}, token) => {
  try {
    state.stones = []
    commit(type.RESET_STONE_FILTERS, token);
    commit(type.SET_STONES);
  } catch (error) {
    console.error(error);
  }

}

